import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { format } from 'utils/formatUtils';

import {
  newCalculationStarted,
  historyEntryDeleted,
  historyMetricsSelector,
  historyIdxSelector
} from 'redux/historySlice';

import {
  StyledCalciteList,
  StyledCalciteListItem
} from './CalculationTabs-styled';

import { CalciteButton } from 'components/Calcite';

const CalculationTabs: React.FC = () => {
  const dispatch = useDispatch();
  const historyMetrics = useSelector(historyMetricsSelector);
  const historyIdx = useSelector(historyIdxSelector);

  const onDeleteCalculation = (idx: number) => {
    dispatch(historyEntryDeleted(idx));
    if (idx === historyIdx) {
      dispatch(newCalculationStarted());
    }
  };

  return (
    <StyledCalciteList>
      {historyMetrics.map(
        ({ numberOfFeatures, averageSizeOfFeaturesBytes }, idx) => (
          <StyledCalciteListItem
            key={`${numberOfFeatures}_${idx}`}
            label={`${numberOfFeatures} Feature${
              numberOfFeatures > 1 ? 's' : ''
            }`}
            description={`Average size ${format(
              averageSizeOfFeaturesBytes
            )} bytes`}
            selected={idx === historyIdx}
          >
            <CalciteButton
              slot="actions-end"
              appearance="transparent"
              kind="neutral"
              iconStart="trash"
              onClick={() => onDeleteCalculation(idx)}
            />
          </StyledCalciteListItem>
        )
      )}
      {historyIdx === -1 ? (
        <StyledCalciteListItem label="Current Calculation" selected />
      ) : null}
    </StyledCalciteList>
  );
};

export default CalculationTabs;
